import { useMemo } from "react";
import { useIntl } from "react-intl";
import commonMessages from "../../../common/messages";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const result = useMemo(() => {
    const translations = {
      defaultError: formatMessage(commonMessages.defaultError),
      btnPatientEdit: formatMessage(messages.btnPatientEdit),
      btnPatientSave: formatMessage(messages.btnPatientSave),
      btnPatientCancel: formatMessage(messages.btnPatientCancel),
      btnMerge: formatMessage(messages.btnMerge),
    };

    return { translations };
  }, [formatMessage]);
  return result;
};
export default useTranslations;
